import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

import SweetAlert from 'sweetalert-react';
import withSizes from 'react-sizes';

import * as Utils from '../../utils/utils'
import * as Products from '../../utils/productHelpers';
import * as Cart from '../../utils/cartHelper'
import * as CartActions from '../../actions/cartActions'
import * as ProductsActions from '../../actions/productsActions';

import ProductCard from '../../components/commons/cards/ProductCard'
import QuantitySelector from '../../components/commons/quantity-selector/QuantitySelector'
import QuantitySelectorMobile from '../../components/commons/quantity-selector/QuantitySelectorMobile'
import SizeSelector from '../../components/commons/size-selector/SizeSelector'
import ProductDefaultImage from '../../assets/images/product-default-image.jpg'
import Loader from '../../components/commons/loader/loader';
import SuggestionCard from '../../components/commons/cards/SuggestionCard';
import { gtagHelper } from '../../utils/gtagHelper'

class ProductDetailsPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      minimumQuantity: 1,
      quantity: 1,
      isItemAddedToCart: false,
      showAlert: false,
      swalParams: {
        title: ""
      },
    }

    this.addToCart = this.addToCart.bind(this);
    this.onChangeProductQuantity = this.onChangeProductQuantity.bind(this);
    this.renderContentForDesktop = this.renderContentForDesktop.bind(this);
    this.renderContentForMobile = this.renderContentForMobile.bind(this);
    this.renderBundleDiscountInfo = this.renderBundleDiscountInfo.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const {location, match} = this.props;
    const productId = match && match.params
      ? match.params.productId
      : null;
    if (productId)
      this.props.dispatch(ProductsActions.getProductDetails(productId, response => {
        if(!response.status) {
          this.setState({
            showAlert: true,
            swalParams: {
              title: "Something went wrong, please try again later!",
              type: "error",
              showConfirmButton: false
            }
          });
        }

        if (response.status) {
          const { product, similar } = response.data;
          gtagHelper(product,similar);
        }
      }));

    this.setState({
      isItemAddedToCart: !!Cart.isProductExist(productId)
    })
  }

  componentWillReceiveProps(newProps){
    const {location, match} = newProps;
    const productId = match && match.params
      ? match.params.productId
      : null;
      // console.log("CWRP",productId);
      // console.log("This props",this.props.match.params.productId);
    if (productId && productId != this.props.match.params.productId){
      // console.log("We get another productId in params");
      this.props.dispatch(ProductsActions.getProductDetails(productId, response => {
        if(!response.status) {
          this.setState({
            showAlert: true,
            swalParams: {
              title: "Something went wrong, please try again later!",
              type: "error",
              showConfirmButton: false
            }
          });
        }

        if (response.status) {
          const { product, similar } = response.data;
          // id is required
          gtagHelper(product, similar)
        }
      }));
      window.scrollTo(0, 0);
    }else{
      // console.log("Need not to dispatch product request as we get same productId");
    }
  }

  getAddressValidation() {
    const validationStatus = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_VALIDATION_STATUS);
    if (validationStatus && typeof validationStatus === 'object' && 'status' in validationStatus) {
      return !!validationStatus.status;
    }
    return validationStatus === undefined || validationStatus === null ? true : !!validationStatus;
  }

  getProductDisplayPrice(product) {
    if (!product) {
      return '';
    }
    const price = product.PriceB !== undefined && product.PriceB !== null
      ? product.PriceB
      : product.Price;
    if (price === undefined || price === null) {
      return '';
    }
    const numericPrice = Number(price);
    return Number.isNaN(numericPrice) ? '' : numericPrice.toFixed(2);
  }

  getVariantDisplayPrice(variant) {
    if (!variant) {
      return '';
    }
    const price = variant.PriceB !== undefined && variant.PriceB !== null
      ? variant.PriceB
      : variant.Price;
    if (price === undefined || price === null) {
      return '';
    }
    const numericPrice = Number(price);
    return Number.isNaN(numericPrice) ? '' : numericPrice.toFixed(2);
  }

  isProductOutOfStock(product) {
    if (!product) {
      return false;
    }
    if (typeof product.isOutOfStock === 'boolean') {
      return product.isOutOfStock;
    }
    if (typeof product.stockStatus === 'string') {
      return product.stockStatus.toLowerCase() === 'out of stock';
    }
    return !(product.Qty > 0);
  }
    
  render() {
    const {isMobile, loading} = this.props;
    const {showAlert, swalParams} = this.state;
    return (
      <div className={`page product-details-page ${isMobile ? 'mobile' : ''}`}>
        <div className="container">
          {!isMobile ? this.renderContentForDesktop() : this.renderContentForMobile()}
        </div>
        <Loader visibility={loading}/>
        <SweetAlert show={showAlert}
          customClass={"with-close"}
          showCancelButton
          cancelButtonText={"x"}
          {...swalParams}
          onCancel={()=> this.setState({showAlert:false})}
          onConfirm={() => this.setState({showAlert: false})}/>
      </div>
    )
  }

  renderContentForDesktop() {

    const productDetals = Utils.toJS(this.props.productDetails);
    const product = productDetals ? productDetals.product : {};
    const variants = productDetals ? productDetals.variants : [];
    const discounts = productDetals && productDetals.product ?
      productDetals.product.QuantityDiscount : [];
    const similarProducts = productDetals ? productDetals.similar : [];
    const {quantity, minimumQuantity} = this.state;
    const productPrice = this.getProductDisplayPrice(product);
    const isOutOfStock = this.isProductOutOfStock(product);
    const bundledDiscount = product ? product.QuantityDiscountOddItems
      ? discounts.filter(d => d.quantity <= quantity)
        ? discounts.filter(d => d.quantity <= quantity)[0]
          : undefined
            : discounts.find(d => d.quantity === quantity)
              : undefined;
    const highlightDescriptions = [
      product && product["Sub Description 2"],
      product && product["Sub Description 3"]
    ].filter(Boolean);
    return (
      <div className="product-details-shell">
        <section className="product-hero-card">
          <div className="product-hero-grid">
            <div className="product-gallery-col">
              <div className="floating-pills">
                {product && product.OnSale ? (
                  <span className="pill pill-sale">On Sale</span>
                ) : null}
                {bundledDiscount ? (
                  <span className="pill pill-bundle">Bundle & Save</span>
                ) : null}
                {isOutOfStock ? (
                  <span className="pill pill-out">{product && product.stockStatus ? product.stockStatus : 'Out of Stock'}</span>
                ) : null}
              </div>
              <div className="product-image-surface">
                <img
                  src={
                    product && product.image
                      ? product.image
                      : ProductDefaultImage
                  }
                  className="product-image"
                  onError={e => {
                    return (e.target.src = ProductDefaultImage);
                  }}
                  alt={product && product.Description ? product.Description : "Product"}
                />
              </div>
              <div className="gallery-meta">
                <span className="meta-chip accent">30-minute delivery in Downtown LA</span>
                <span className="meta-chip">Chilled chain kept for beer & wine</span>
              </div>
            </div>
            <div className="product-summary-col">
              <div className="breadcrumb-row">
                {product && product.Department ? (
                  <Link
                    to={`/products?department=${encodeURIComponent(product.Department)}`}
                    className="crumb"
                  >
                    {product.Department}
                  </Link>
                ) : null}
                {product && product.Category ? (
                  <span className="crumb-inline">
                    <span className="crumb-divider">•</span>
                    <Link
                      to={`/products?category=${encodeURIComponent(product.Category)}`}
                      className="crumb"
                    >
                      {product.Category}
                    </Link>
                  </span>
                ) : null}
              </div>
              <h1 className="info-title">{product && product.Description ? product.Description : ""}</h1>
              {highlightDescriptions.length ? (
                <div className="info-description sub-description">
                  {highlightDescriptions.join(" • ")}
                </div>
              ) : null}
              {product && product["Item Lookup Code"] ? (
                <div className="info-description sku">SKU #{product["Item Lookup Code"]}</div>
              ) : null}

              {this.getAddressValidation() ? (
                <div className="price-panel">
                  {bundledDiscount ? (
                    <React.Fragment>
                      <div className="price-text sale">${bundledDiscount && bundledDiscount.priceB ? bundledDiscount.priceB.toFixed(2) : ""}</div>
                      <div className="sale-original-price-text">
                        <s>{product && product.PriceB ? `$${productPrice}` : ""}</s>
                      </div>
                      <div className="price-note">Buy {bundledDiscount.quantity}+ to unlock bundle pricing</div>
                    </React.Fragment>
                  ) : product && product.OnSale ? (
                    <React.Fragment>
                      <div className="price-text sale">{product && product.SalePrice ? `$${product.SalePrice.toFixed(2)}` : ""}</div>
                      <div className="sale-original-price-text">
                        <s>{product && product.PriceB ? `$${productPrice}` : ""}</s>
                      </div>
                      <div className="price-note">Limited-time pricing</div>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <div className="price-text">{product && product.PriceB ? `$${productPrice}` : ""}</div>
                      <div className="price-note">Tax & CRV calculated at checkout</div>
                    </React.Fragment>
                  )}
                </div>
              ) : null}

              {this.renderBundleDiscountInfo(discounts)}

              {product && product["Ext'd Description"] ? (
                <div className="product-story">
                  <div className="info-subtitle">Product Details</div>
                  <div className="info-description">{product["Ext'd Description"]}</div>
                </div>
              ) : null}

              {variants && variants.length > 1 ? (
                <div className="variants">
                  {variants.map(variant => {
                    return (
                      <Link to={`/products/${variant._id}`} key={variant._id}>
                        <div className={`variant ${variant._id === product._id ? "active" : ""}`}>
                          <div className="size">{variant.Size}</div>
                          <div className="price">
                            ${variant._id === product._id ? productPrice : this.getVariantDisplayPrice(variant)}
                          </div>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              ) : null}

              <div className="purchase-panel">
                <div className="info-subtitle">Ready to ship</div>
                <div className="quantity-selector-row">
                  <QuantitySelector
                    quantity={quantity}
                    onChangeQuantity={this.onChangeProductQuantity}
                    minimumQuantity={minimumQuantity}
                  />
                  {product && product["Size"] ? <SizeSelector selectedSize={product["Size"]} /> : null}
                </div>
                <div className="button-add-to-bag" onClick={() => this.addToCart()}>
                  Add to Bag
                </div>
                <div className="purchase-note">Delivery availability confirmed at checkout</div>
                <div className="share-row">
                  <span className="info-subtitle">Share</span>
                  <div className="social-links">
                    <a href={getTwitterShareUrl()} target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-twitter" />
                    </a>
                    <a href={getFacebookShareUrl()} target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-facebook" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="suggested-products-container">
          <div className="suggested-header">
            <div>
              <p className="eyebrow">Curated for you</p>
              <h2 className="row-title">You May Also Like</h2>
            </div>
            <Link to="/products" className="text-link">
              View all products
            </Link>
          </div>
          <div className="row">
            {similarProducts &&
              similarProducts.map(product => {
                return (
                  <div className="col-lg-2 col-md-3 product-card-container no-links" key={product._id}>
                    <SuggestionCard
                      data={product}
                      onSelectProduct={() => this.exploreProduct(product)}
                      onAddToCart={() => this.addToCart(product)}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    )
  }

  renderContentForMobile() {
    const productDetals = Utils.toJS(this.props.productDetails);
    const product = productDetals ? productDetals.product : {};
    const variants = productDetals ? productDetals.variants : [];
    const discounts = productDetals && productDetals.product ?
      productDetals.product.QuantityDiscount : [];
    const similarProducts = productDetals ? productDetals.similar : [];
    const {quantity, minimumQuantity} = this.state;
    const productPrice = this.getProductDisplayPrice(product);
    const isOutOfStock = this.isProductOutOfStock(product);

    const bundledDiscount = product ? product.QuantityDiscountOddItems
      ? discounts.filter(d => d.quantity <= quantity) 
        ? discounts.filter(d => d.quantity <= quantity)[0] 
          : undefined
            : discounts.find(d => d.quantity === quantity)
              : undefined;

    return (
      <div>
        <div className="product-info-header">
          <div className="product-image-container">
            <img
              src={
                product && product.image
                  ? product.image
                  : ProductDefaultImage
              }
              className="product-image"
              onError={e => {
                return (e.target.src = ProductDefaultImage);
              }}
              alt={product && product.Description ? product.Description : "Product"}
            />
          </div>
          <div className="product-info">
            <div className="info-title">{product && product.Description ? product.Description : ""}</div>
            {isOutOfStock ? (
              <div className="stock-status">{product && product.stockStatus ? product.stockStatus : 'Out of Stock'}</div>
            ) : null}
            <div className="info-description">{product && product.Category}</div>
            {product && product.OnSale ? (
              <div className="price-block">
                <h2 className="sale-price-text">
                  {product && product.SalePrice ? `$${product.SalePrice.toFixed(2)}` : ""}
                </h2>
                <h2 className="sale-original-price-text">
                  <s>{product && product.PriceB ? `$${productPrice}` : ""}</s>
                </h2>
              </div>
            ) : bundledDiscount ? (
              <div className="price-block">
                <h2 className="sale-price-text">
                  {bundledDiscount && bundledDiscount.priceB ? `$${bundledDiscount.priceB.toFixed(2)}` : ""}
                </h2>
                <h2 className="sale-original-price-text">
                  <s>{product && product.PriceB ? `$${productPrice}` : ""}</s>
                </h2>
              </div>
            ) : (
              <h2 className="price-text">{product && product.PriceB ? `$${productPrice}` : ""}</h2>
            )}

            {product && product["Sub Description 2"] ? (
              <div className="info-description sub-description">{product["Sub Description 2"]}</div>
            ) : null}
            {product && product["Sub Description 3"] ? (
              <div className="info-description sub-description">{product["Sub Description 3"]}</div>
            ) : null}
            {product && product["Ext'd Description"] ? (
              <div className="info-description">{product["Ext'd Description"]}</div>
            ) : null}
          </div>
        </div>
        {this.renderBundleDiscountInfo(discounts)}
        {variants && variants.length > 1 ? (
          <div className="variants">
            {variants.map(variant => {
              return (
                <Link to={`/products/${variant._id}`} key={variant._id}>
                  <div className={`variant ${variant._id === product._id ? "active" : ""}`}>
                    <div className="size">{variant.Size}</div>
                    <div className="price">
                      ${variant._id === product._id ? productPrice : this.getVariantDisplayPrice(variant)}
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        ) : null}
        <div className="product-info-footer">
          {product && product["Size"] ? <SizeSelector selectedSize={product["Size"]} /> : null}
          <QuantitySelectorMobile
            quantity={quantity}
            onChangeQuantity={this.onChangeProductQuantity}
            minimumQuantity={minimumQuantity}
          />
        </div>
        <div className="button button-block button-blue add-to-cart-button" onClick={() => this.addToCart()}>
          Add to Bag
        </div>
        <div className="suggested-products-container">
          <h2 className="section-header">You May Also Like</h2>
          <div className="row suggested-products">
            {similarProducts &&
              similarProducts.map(product => {
                return (
                  <div className="product-card-container no-links" key={product._id}>
                    <SuggestionCard
                      data={product}
                      onSelectProduct={() => this.exploreProduct(product)}
                      onAddToCart={() => this.addToCart(product, true)}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    )
  }

  renderBundleDiscountInfo(discounts) {

    return (
      (discounts && discounts.length > 0)?
      <div className="discounts">
        <div className="discount-title">Bundle & Save</div>
        <div className="discount-list">
          { discounts.map(d => {
            return (
              <span className="discount-chip" key={d.quantity} >Buy {d.quantity} at ${parseFloat(d.priceB).toFixed(2)} each</span>
            );
          }) }
        </div>
      </div>:null
    )
  }

  exploreProduct(product) {
    this.props.history.push(`/products/${product._id}`)
  }

  onChangeProductQuantity(newQuantity) {

    this.setState({ quantity: newQuantity });

  }

  addToCart(product) {

    const productDetals = Utils.toJS(this.props.productDetails);
    const { quantity } = this.state;
    product = product
      ? product
      : (productDetals
        ? productDetals.product
        : {});
    if (!product) {
      this.setState({
        showAlert: true,
        swalParams: {
          title: 'Something went wrong!',
          type: "error",
          showConfirmButton: false
        }
      })
      // setTimeout(() => this.setState({showAlert: false}), 1500);
      return;
    }
    Utils.addToCart(product, quantity ?  quantity : 1)
      .then(() => {
        this.setState({
          isItemAddedToCart: true,
          showAlert: true,
          swalParams: {
            title: "Product added to cart successfully.",
            type: "success",
            showConfirmButton: false,
          }
        })
        setTimeout(() => this.setState({ showAlert: false }), 1500);
       })
      .catch(err => {
        this.setState({
          showAlert: true,
          swalParams: {
            title: err.title,
            type: "warning",
            showCloseButton: true
          }
        });
      });
  }
}

function getFacebookShareUrl() {

  let pageUrl = window.location.href;
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(pageUrl)}`;
}

function getTwitterShareUrl() {

  let pageUrl = window.location.href;
  return `https://twitter.com/home?status=${encodeURI(pageUrl)}`;
}

const mapSizesToProps = ({ width }) => ({
    isMobile: width < 992
});

export default withSizes(mapSizesToProps)(connect((state) => {
  return {
    productDetails: state.getIn(['products', 'recentProduct']),
    similarProducts: state.getIn(['products', 'similarProducts']),
    loading: state.getIn(['products', 'loading']),
    error: state.getIn(['products', 'error'])
  };
})(ProductDetailsPage));



// WEBPACK FOOTER //
// ./src/containers/products/ProductDetailsPage.js